import React from 'react';
import AppHeader from '../AppHeader/Index';
import SideMenu from '../SideMenu/Index';
import PageContent from '../PageContent/Index';
import Footer from '../AppFooter/Index';
import './super.css';

function SuperRoute() {
  return (
    <div className="super-wrapper">
      <div className="super-header">
        <AppHeader />
      </div>
      <div className="super-main">
        <SideMenu />
        <PageContent/>
      </div>
      <div className="super-footer">
        <Footer />
      </div>
    </div>
  );
}

export default SuperRoute;
